module.exports = __webpack_public_path__ + "front/img/p1.6d1a3fd6.jpg";